export { uploadOSS } from '@/utils'
import { fetchData } from '@/api'

/**
 * userLoginInfo
 */
export const userLoginInfo = (data, carryToken = true) =>
	fetchData(
		{
			url: '/user_loginInfo.cls.php',
			data
		},
		carryToken
	)

/**
 * 获取json数据
 * @returns {Promise<Response>}
 */
export const getAiToolsJson = async (data) =>
	fetchData({
		url: '/get_aiToolsJson.cls.php',
		data
	})

/**
 * 获取markdown数据
 * @returns {Promise<Response>}
 */
export const getOtherMarkdown = async (data) =>
	fetchData({
		url: '/get_otherMarkdown.cls.php',
		data
	})
